import { forwardRef, useEffect, useRef } from "react";
import { Grid2 as Grid, Typography } from "@mui/material";
import FileUploadIcon from "@mui/icons-material/FileUpload";

import { Avatar } from "../../Avatar";
import { useSinglePhotoPickerController } from "./controller";
import { PhotoPickerContainer, PhotoPickerUploadButton } from "./styles";
import { SinglePhotoPickerProps } from "./types";

export const SinglePhotoPicker = forwardRef<
  HTMLInputElement,
  SinglePhotoPickerProps
>(
  (
    {
      value = "",
      label,
      size = 100,
      shape = "circular",
      onChange,
      helperText,
      error,
    },
    ref
  ) => {
    const { image, handleChange, handleRemove } =
      useSinglePhotoPickerController({
        value,
        onChange,
      });

    const fileInputRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
      if (ref) {
        if (typeof ref === "function") {
          ref(fileInputRef.current);
        } else {
          ref.current = fileInputRef.current;
        }
      }
    }, [ref]);

    return (
      <Grid container spacing={1} size={{ xs: 12 }}>
        {label && (
          <Grid size={{ xs: 12 }}>
            <Typography style={{ fontSize: 14, color: "primary.main" }}>
              {label}
            </Typography>
          </Grid>
        )}

        <Grid size={{ xs: 12 }}>
          <PhotoPickerContainer
            buttonSize={size}
            shape={shape}
            onClick={() => !image && fileInputRef.current?.click()}
          >
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleChange}
              accept="image/*"
            />

            <Avatar
              src={image}
              size={size}
              shape={shape}
              onRemove={handleRemove}
            />

            {!image && (
              <PhotoPickerUploadButton buttonSize={size} shape={shape}>
                <FileUploadIcon color="action" />
              </PhotoPickerUploadButton>
            )}
          </PhotoPickerContainer>
          {error && (
            <Typography
              style={{ fontSize: 12, color: "#d32f2f", marginTop: 4 }}
              variant="caption"
            >
              {helperText}
            </Typography>
          )}
        </Grid>
      </Grid>
    );
  }
);

SinglePhotoPicker.displayName = "SinglePhotoPicker";
